import { render, staticRenderFns } from "./BlogAuthor.vue?vue&type=template&id=2f0ddb89"
import script from "./BlogAuthor.vue?vue&type=script&lang=js"
export * from "./BlogAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports